import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

const GroupButtons = ({ children, className, align, bordered }) => (
    <div className={classNames(styles.root, className, bordered ? styles.bordered : null, styles[align])}>
        {React.Children.map(children, (item, key) => (
            <div key={key} className={styles.item}>
                {item}
            </div>
        ))}
    </div>
);

GroupButtons.propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    align: PropTypes.oneOf(['left', 'right', 'center']),
    bordered: PropTypes.bool,
};

export default GroupButtons;
